// Utility to initiate SSO login (PKCE flow)
export function initiateSSOLogin(redirectUri) {
  const AUTH_ENDPOINT = process.env.REACT_APP_AUTH_ENDPOINT;
  const PKCE_ENDPOINT = process.env.REACT_APP_PKCE_ENDPOINT;
  const CONSUMER_KEY = process.env.REACT_APP_CONSUMER_KEY;

  // Fetch PKCE code challenge and verifier, then redirect
  fetch(PKCE_ENDPOINT)
    .then(res => res.json())
    .then(({ code_challenge, code_verifier }) => {
      sessionStorage.setItem("pkce_code_verifier", code_verifier);
      const redirectUrl = `${AUTH_ENDPOINT}?response_type=code&client_id=${CONSUMER_KEY}` +
        `&redirect_uri=${encodeURIComponent(redirectUri)}` +
        `&code_challenge=${code_challenge}&code_challenge_method=S256`;
      window.location.href = redirectUrl;
    })
    .catch(() => {
      // fallback: reload page to trigger SSO
      window.location.reload();
    });
}
